import { useScanDataReportedTransactionsStoreLevelDetailsQuery } from '@occc/graphql';
import {
  usePaginatedQuery,
  PaginationInfo,
  PaginationHandler,
} from '@occc-app/hooks/usePaginatedQuery';

type UseScanDataReportedTransactionsStoreLevelDetailsParams = {
  submissionDateEquals: string;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
  search?: string;
};

export const useScanDataReportedTransactionsStoreLevelDetails = ({
  submissionDateEquals,
  paginationInfo,
  onPageChange,
  search,
}: UseScanDataReportedTransactionsStoreLevelDetailsParams) => {
  return usePaginatedQuery(
    useScanDataReportedTransactionsStoreLevelDetailsQuery,
    'scanDataReportedTransactionsStoreLevelDetails.pageInfo',
    undefined,
    {
      variables: {
        filter: {
          submissionDateEquals,
          siteAccountSubmitterSearch: search,
        },
      },
    },
    paginationInfo,
    onPageChange,
  );
};
